// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 913 ? "default" : chunkId) + "-legacy." + {"386":"179d63f7","913":"7347c53f"}[chunkId] + ".js";
};